<div class="feedback-panel">
  <div class="title">How do you like Glimpse?</div>

  @if (!ratedPositive && !ratedNegative) {
    <div class="rating-box">
      <bar-rating [max]="5" (rateChange)="onRate($event)"></bar-rating>
      <button mat-button (click)="askMeLater()">Ask me later</button>
    </div>
  }

  @if (ratedPositive) {
    <div>
      Awesome, thank you 👍
    </div>
  }
</div>
